import {
    SHOW_ALERT_HEADER,
} from './music-actions';
  
export const flagAlertBelt = (value) => ({ type: SHOW_ALERT_HEADER, value });



// WEBPACK FOOTER //
// ./src/actions/musica/alert-header-action.js